import React, { useContext } from "react"

interface Props {
  L: any
  map: any
}

// Contexts
import GlobalContext from '../../contexts/global'
let polygons: any[] = [];
export default function Direction({ L, map }: Props) {

  const {
    origin,
    originLocation,
    destination,
    destinationLocation,
    directions,
  } = useContext(GlobalContext)

  for (let i = 0; i < L.Polyline.markers.length; i++) {
    map.removeLayer(L.Polyline.markers[i]);
  }
  L.Polyline.markers = [];
  for (let i = 0; i < L.Polyline.polylines.length; i++) {
    map.removeLayer(L.Polyline.polylines[i]);
  }
  L.Polyline.polylines = [];
  for (const polygon of polygons) {
    polygon.remove()
  }
  polygons = [];

  map.setView([Number(process.env.REACT_APP_LAT), Number(process.env.REACT_APP_LNG)], 5);

  if (origin && originLocation && destination && destinationLocation && directions) {
    L.Polyline.markers.push(
      L.marker({
        lat: originLocation.lat,
        lng: originLocation.lng,
      }, {
        icon: new L.Icon({
          iconUrl: require('../../resources/media/start.png'),
          iconSize: [50, 61],
          popupAnchor: [0, -30]
        }),
      }).addTo(map).bindPopup(originLocation.address, {
        className: "leaflet-address",
        autoClose: false,
      }).openPopup(),
      L.marker({
        lat: destinationLocation.lat,
        lng: destinationLocation.lng,
      }, {
        icon: new L.Icon({
          iconUrl: require('../../resources/media/end.png'),
          iconSize: [50, 61],
          popupAnchor: [0, -30]
        }),
      }).addTo(map).openPopup(),
      //   .addTo(map).bindPopup(destinationLocation.address, {
      //   className: "leaflet-address",
      //   autoClose: false,
      // }).openPopup(),
    )
    polygons.push(L.polygon(origin.coordinates.map(({ lat, lng }) => [lat, lng])).addTo(map))
    polygons.push(L.polygon(destination.coordinates.map(({ lat, lng }) => [lat, lng])).addTo(map))
    const { routes } = directions;
    if (routes.length) {
      for (let k = 0; k < Object.keys(routes).length; k++) {
        const color = '#03ac13';
        for (let i = 0; i < Object.keys(routes[0].legs).length; i++) {
          for (let j = 0; j < Object.keys(routes[0].legs[i].steps).length; j++) {
            const stepPolyLine = routes[0].legs[i].steps[j].polyline;
            L.Polyline.polylines[L.Polyline.polylines.length] = L.Polyline.fromEncoded(stepPolyLine, {
              color: color
            }).addTo(map);
          }
        }
      }
    }
  }

  return null;
}
